import { Quote } from "lucide-react";
import { REVIEWS } from "@/data";
import { Reveal, MaskLine } from "@/components/Reveal";

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="mb-16 lg:mb-24 max-w-3xl">
        <Reveal>
          <p className="eyebrow mb-5">Press &amp; Patrons</p>
        </Reveal>
        <h2 className="font-display font-medium leading-[1.02] tracking-tight text-4xl sm:text-5xl lg:text-6xl">
          <MaskLine>Kind words,</MaskLine>
          <MaskLine delay={0.12}>
            <span className="italic text-[#C85A32]">warm</span> crumbs.
          </MaskLine>
        </h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <Reveal className="lg:col-span-7 h-full">
          <figure className="h-full flex flex-col justify-between rounded-3xl border border-[rgba(28,19,14,0.12)] bg-[#F8F3EA] p-8 lg:p-12">
            <Quote size={28} className="text-[#C85A32] mb-8" />
            <blockquote className="font-display italic font-medium text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.15] tracking-tight">
              {REVIEWS.main.quote}
            </blockquote>
            <figcaption className="mt-10 font-mono-accent text-xs tracking-[0.2em] uppercase text-[#1C130E]/55">
              {REVIEWS.main.by}
            </figcaption>
          </figure>
        </Reveal>
        <div className="lg:col-span-5 grid grid-cols-1 gap-6 h-full">
          {REVIEWS.side.map((r) => (
            <Reveal key={r.by} className="h-full">
              <figure
                className={`h-full flex flex-col justify-between rounded-3xl p-8 ${
                  r.dark ? "bg-[#1C130E] text-[#FDFBF7]" : "border border-[rgba(28,19,14,0.12)]"
                }`}
              >
                <Quote size={22} className="text-[#C85A32] mb-6" />
                <blockquote className="font-display italic text-xl sm:text-2xl leading-snug tracking-tight">
                  {r.quote}
                </blockquote>
                <figcaption
                  className={`mt-8 font-mono-accent text-xs tracking-[0.2em] uppercase ${
                    r.dark ? "text-[#FDFBF7]/55" : "text-[#1C130E]/55"
                  }`}
                >
                  {r.by}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
